<button
  type="button"
  class="ks-theme-toggle"
  [attr.aria-label]="label()"
  [attr.title]="label()"
  [attr.aria-pressed]="isDark()"
  (click)="toggle()">
  <span class="ks-theme-toggle__icon" aria-hidden="true">
    @if (isDark()) {
      <i class="bi bi-sun-fill"></i>
    } @else {
      <i class="bi bi-moon-stars-fill"></i>
    }
  </span>
</button>
